<template>
  <div>
    <v-text-field
      filled
      v-model="localDescripcion"
      autofocus
      :label="label"
      id="descripcion"
      v-validate="'required|max:500'"
      :error-messages="errors.collect('descripcion')"
      data-vv-name="descripcion"
      :counter="100"
      maxlength="100"
      required
      :disabled="disabled"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "form.producto.descripcion",
  inject: ["$validator"],

  props: {
    descripcion: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      default: "Nombre del producto",
      required: false,
    },
  },

  data() {
    return {
      localDescripcion: this.descripcion,
    };
  },

  watch: {
    // Si el padre actualiza la prop, sincronizamos la local
    descripcion(newVal) {
      this.localDescripcion = newVal;
    },
    // Si el usuario edita el campo, emitimos hacia el padre
    localDescripcion(newVal) {
      this.$emit("update:descripcion", newVal);
    },
  },
};
</script>
